import type { JSX } from 'react'

/**
 * The wordmark, as the approved brand lockup (design/brand/BRAND.md).
 *
 * The mark is served from `/design/`, the same static copy of the design layer
 * the tokens and the Atlas stylesheet come from (`scripts/sync-design.sh`), so
 * there is one copy of the SVG in the repository rather than one per workspace.
 *
 * `alt=""` on the mark and the word beside it as real text: the two together
 * are one lockup, and reading "AugRank AugRank" is what an alt on both gives a
 * screen reader.
 */
export function Lockup({ size = '1.75rem' }: { size?: string }): JSX.Element {
  return (
    <>
      <img src="/design/augrank-mark.svg" alt="" style={{ height: size }} />
      <span className="app-side__word">
        Aug<em>Rank</em>
      </span>
    </>
  )
}
